<div class="flex-fill flex-column">
  <ssg-header></ssg-header>
  <div class="ee-pay-height psg-background">
    <router-outlet name="eepay"></router-outlet>
    <ssg-loading-spinner></ssg-loading-spinner>
    <ukg-popover>{{popoverText}}</ukg-popover>
    <!--Specifically meant for screen readers and accessibility-->
    <div aria-live="polite" class="hidden-accessible title-margin">
      {{accessibilityPageTitle}}
    </div>
  </div>
</div>
<ssg-pendo></ssg-pendo>
